import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import CustomText from "pages/_components/CustomText/CustomText";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React from "react";
import { useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import EcheckRequestSummaryBody from "./components/Summary";

const EcheckRequestSummaryPage = () => {
    const { requestEcheckAmountData } = useSelector((state) => state.echecks);
    const { echeckTicket } = useSelector((state) => state.echecks);
    useConfirmTransaction(requestEcheckAmountData, echeckTicket, "echecks/requestAmount");

    return (
        <>
            <Notification scopeToShow="TransferSummaryPage" />
            <ResponsiveHeader id="echecks.request.title" />
            <MainContainer>
                <div className="container">
                    <CustomText
                        text="echeq.summary.confirm"
                        textType="I18N"
                        className="discounts-echeq-review__date-control"
                    />
                    <EcheckRequestSummaryBody
                        idAccount={requestEcheckAmountData.idAccount}
                        amount={requestEcheckAmountData.amount}
                    />
                    <GeneralCredentialForm
                        transactionData={requestEcheckAmountData}
                        action={echeckActions.requestEcheckAmount}
                        idActivity="echeq.updateAmount"
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default EcheckRequestSummaryPage;
